var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ca_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.67,
  d: "M.182 3.025h512v512h-512z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ca_svg__a)",
  transform: "translate(-.182 -3.025)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.32 3.025h362.275v512H81.32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bf0a30",
  d: "M-99.818 3.025H81.32v512H-99.818zm543.413 0h181.138v512H443.595zM135.49 250.44l-14.067 4.808 65.456 57.446c4.95 14.764-1.72 19.116-5.97 26.86l71.06-9.02-1.85 71.512 14.718-.423-3.21-70.918 71.13 8.432c-4.402-9.297-8.32-14.233-4.247-29.098l65.414-54.426-11.447-4.144c-9.36-7.222 4.044-34.784 6.066-52.178 0 0-38.195 13.135-40.698 6.262l-9.727-18.685-34.747 38.17c-3.796.91-5.413-.6-6.304-3.808l16.053-79.766-25.42 14.297c-2.128.91-4.256.125-5.658-2.355l-24.445-49.073-25.21 50.952c-1.9 1.826-3.802 2.037-5.38.796L202.8 142.505l14.53 79.143c-1.156 3.142-3.924 4.026-7.18 2.325l-33.216-37.737c-4.345 6.962-7.29 18.336-13.033 20.885-5.744 2.388-24.98-4.822-37.873-7.636 4.404 15.895 18.176 42.302 9.46 50.957z"
}))));
export default SvgCa;